export default __webpack_public_path__ + "static/media/A16.98d88e18.png";